import { Flex, Text } from '@chakra-ui/react';
import { Checkbox, FormFeedback, OutlineCard } from '@morressier/alembic';
import { useFormContext } from 'react-hook-form';
import { FieldLabel } from 'src/components/Field';
import { ISubmissionFormData } from 'src/contexts/FormContext';
import { FormFieldCheckboxArray } from '@publishing-engine/domain/types/article';
import { get } from 'lodash';

const GeneralClassifications = ({
  config
}: {
  config: FormFieldCheckboxArray;
}) => {
  const {
    formState: { errors },
    watch,
    setValue,
    clearErrors
  } = useFormContext<ISubmissionFormData>();
  const {
    params: { validations, labels },
    caseDataFields: { main: field }
  } = config;

  const value = (watch(field as any) as string[]) || [];
  const error = get(errors, field);

  const options = Object.entries(labels.options || {}).map(([key, opt]) => ({
    id: key,
    main: opt.main,
    secondary: opt.secondary
  }));

  const handleChange = (checked: boolean, itemId: string) => {
    clearErrors(field as any);
    let next: string[];
    if (checked) {
      next = itemId === 'not_applicable'
        ? ['not_applicable']
        : [...value.filter(v => v !== 'not_applicable'), itemId];
    } else {
      next = value.filter(v => v !== itemId);
    }
    setValue(field as any, next, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true
    });
  };

  return (
    <OutlineCard width="100%" padding={4}>
      <Flex flexDirection="column" gap={4} width="100%">
        <FieldLabel
          isRequired={validations.required}
          label={labels.main}
          subText={labels.subtitle}
          helpText={labels.helpText}
        />

        <Flex flexDirection="column" gap={4}>
          {options.map(item => (
            <Checkbox
              key={item.id}
              ariaLabel={item.main}
              id={`${field}-${item.id}`}
              name={field}
              isChecked={value.includes(item.id)}
              onChange={({ target: { checked } }) => handleChange(checked, item.id)}
            >
              <Flex flexDirection="column">
                <Text textStyle="textBody">{item.main}</Text>
                {item.secondary && (
                  <Text textStyle="textBody">{item.secondary}</Text>
                )}
              </Flex>
            </Checkbox>
          ))}
        </Flex>

        {error && (
          <FormFeedback variant="error">
            Please select at least one classification before proceeding.
          </FormFeedback>
        )}
      </Flex>
    </OutlineCard>
  );
};

export default GeneralClassifications;
